module.exports = __webpack_public_path__ + "img/helpdesk_icon.29cd36de.svg";